import {
  CATEGORIES_MENU_HEIGHT,
  LAYOUT_CENTER_COL_WIDTH,
  FOOTER_HEIGHT,
  LAYOUT_LEFT_COL_WIDTH,
  LAYOUT_RIGHT_COL_WIDTH,
  TOPNAV_HEIGHT_DESKTOP,
  TOPNAV_HEIGHT_MOBILE,
} from 'config'
import { styled, theme } from 'lib/theme'
import { Box } from 'primitives/Box'
import { Flex } from 'primitives/Flex'

// Column spacing is flush to particular elements (topnav, footer,etc), this is the gap in px
const GAP = 16

export const LayoutColumns = styled(Flex, {
  width: '100%',
  justifyContent: 'space-between',
  minHeight: 'var(--app-height)',
})

export const LeftColumn = styled(Box, {
  width: '100%',
  // Left column contracts to min content with about <100px before snapping to mobile.
  // center & right columns below are fixed.
  maxWidth: LAYOUT_LEFT_COL_WIDTH,
  position: 'sticky',
  // todo calcated from TOPNAV_HEIGHT_...
  top: '108px',
  margin: '108px 27px 108px 0',
  alignSelf: 'flex-start',
  display: 'none',
  '@lg': {
    display: 'block',
  },
})

// For flexibility its important the center column can have elements rendered at 100% width.
// The main purpose of this column is to offset various elements as an 100% flex column, and apply
// some desktop styling such as border left.
export const CenterColumn = styled(Flex, {
  width: '100%',
  minHeight: '100%',
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'center',
  // note: footer is hidden on mobile
  paddingTop: TOPNAV_HEIGHT_MOBILE + GAP,
  '@lg': {
    borderLeft: `1px solid ${theme.colors.gray400}`,
    padding: `${TOPNAV_HEIGHT_DESKTOP + GAP}px ${GAP}px ${
      FOOTER_HEIGHT + GAP
    }px ${GAP}px`,
    width: LAYOUT_CENTER_COL_WIDTH,
    minWidth: LAYOUT_CENTER_COL_WIDTH,
  },
  variants: {
    noGap: {
      true: {
        paddingTop: TOPNAV_HEIGHT_MOBILE,
        '@lg': {
          padding: `${TOPNAV_HEIGHT_MOBILE}px 0 ${FOOTER_HEIGHT}px 0`,
        },
      },
    },
    // Center column was initially used on the feed which is full width on the x axis.
    // Settings screens with 3 cols on mobile apply padding
    withXPadding: {
      true: { paddingLeft: '16px', paddingRight: '16px' },
    },
    withCategoriesTopbar: {
      true: {
        paddingTop: TOPNAV_HEIGHT_MOBILE + CATEGORIES_MENU_HEIGHT + GAP,
        '@lg': {
          paddingTop: TOPNAV_HEIGHT_DESKTOP + GAP,
        },
      },
    },
  },
})

export const CenterRightColumn = styled(Flex, {
  width: '100%',
  margin: '0 auto',
  maxWidth: LAYOUT_CENTER_COL_WIDTH + LAYOUT_RIGHT_COL_WIDTH,
})

export const RightColumn = styled(Box, {
  minWidth: LAYOUT_RIGHT_COL_WIDTH,
  maxWidth: LAYOUT_RIGHT_COL_WIDTH,
  position: 'sticky',
  top: TOPNAV_HEIGHT_DESKTOP + GAP,
  marginTop: TOPNAV_HEIGHT_DESKTOP + GAP,
  alignSelf: 'flex-start',
  display: 'none',
  '@lg': {
    display: 'block',
  },
})

// Center content to LAYOUT_CENTER_COL_WIDTH (width of center column posts etc)
export const CenterColumnContent = styled(Box, {
  width: '100%',
  margin: '0 auto',
  maxWidth: LAYOUT_CENTER_COL_WIDTH,
})
